export default "__VITE_ASSET__BU5ArdO2__"